import { HttpClient } from "../common/http-client";
import { Environment } from '../environment/app-settings'
import { ITextContentState } from '../store/types'


export const defaultTextContents: ITextContentState = {
  errorPage: {
    heading: "Ooops!",
    mainContent: "Coś poszło nie tak. Robimy wszystko co w naszej mocy, żeby naprawić problem. ",
    tip: "Cofnij się bądź odśwież stronę."
  },
  loaders: {
    default: "Daj nam chwilę",
  },
  sessionEndPage: {
    heading: "Sesja wygasła",
    mainContent: "Ze względów bezpieczeństwa zakończyliśmy sesję.",
    tip: "Rozpocznij proces jeszcze raz."
  },
  failPage: {},
  manualVerificationPage: {},
  contractSigningPage: {},
  bmVerifyPage: {},
  offertPage: {},
  buttons: {},
  modals: {},
  clientPeselReservedPage: {},
  predefinedOfferPage: {},
  contractDonePage: {},
  clientChoiceVerificationPage: {},
  videoVerificationStartPage: {},
  mObywatelIdentityPage: {},
  customClientOfferPage: {},
}

//#region SettingService Instance
let instance: TextContentsService
//#endregion

//#region Interfaces
export interface  ITextContentsFetchModel {
  data: ITextContentState;
}
//#endregion

class TextContentsService {
  private readonly _client: HttpClient;
  private readonly _settingsUrlPath = "settings";
  private readonly _lenTextContents = "/textContents";
  constructor() {
   if (instance) { //SINGLETON DESIGN PATTERN
      throw new Error("New instance cannot be created!!");
   }

   instance = this;
    this._client = new HttpClient(Environment.apiUrl + this._settingsUrlPath);
  }

  public async getTextContents(): Promise<ITextContentsFetchModel> {
   const response = await this._client.get<any>(this._lenTextContents);
   return response.data;
  }
}

let textContentsService = Object.freeze(new TextContentsService())//SINGLETON DESIGN PATTERN
export default textContentsService;